import {config as dateColumnConfig} from '../../../common/DateColumn';

export const prop = 'cliYearEndDate';
export const id = 'yearEndDateColumn';

export const config = (labels) => dateColumnConfig({fullId: id, label: labels.yearEndDate, prop});
